import axios from '@/axios.config';
import { ApiResponse } from '@/types/fetch.type';
import { IToken, ITokenCreate, ITokenUpdate } from '@/types/token.type';
import { AxiosError } from 'axios';
import { useQuery, useMutation } from 'react-query';

const RSSB_INTEGRATION_PREFIX = '';

export const useGetAllTokens = (isActive?: boolean) => {
   return useQuery<ApiResponse<IToken[]>, AxiosError<{ message: string }>>({
      queryKey: ['tokens', isActive],
      queryFn: async () => {
         const { data } = await axios.get(`${RSSB_INTEGRATION_PREFIX}/tokens`, {
            params: { isActive },
         });
         return { data } as ApiResponse<IToken[]>;
      },
   });
};

export const useCreateToken = () => {
   return useMutation<ApiResponse<IToken>, AxiosError<{ message: string }>, ITokenCreate>({
      mutationFn: async (body) => {
         const { data } = await axios.post(`${RSSB_INTEGRATION_PREFIX}/tokens/create`, body);
         return { data } as ApiResponse<IToken>;
      },
   });
};

export const useDecryptToken = () => {
   return useMutation<ApiResponse<{ decryptedToken: string }>, AxiosError<{ message: string }>, string>({
      mutationFn: async (encryptedToken) => {
         const { data } = await axios.post(`${RSSB_INTEGRATION_PREFIX}/tokens/decrypt`, null, {
            params: { encryptedToken },
         });
         return { data } as ApiResponse<{ decryptedToken: string }>;
      },
   });
};

export const useRegenerateToken = () => {
   return useMutation<ApiResponse<IToken>, AxiosError<{ message: string }>, string>({
      mutationFn: async (tokenId) => {
         const { data } = await axios.post(`${RSSB_INTEGRATION_PREFIX}/tokens/${tokenId}/regenerate`);
         return { data } as ApiResponse<IToken>;
      },
   });
};

export const useDeactivateToken = () => {
   return useMutation<ApiResponse<{ message: string }>, AxiosError<{ message: string }>, string>({
      mutationFn: async (tokenId) => {
         const { data } = await axios.put(`${RSSB_INTEGRATION_PREFIX}/tokens/${tokenId}/deactivate`);
         return { data } as ApiResponse<{ message: string }>;
      },
   });
};

export const useActivateToken = () => {
   return useMutation<ApiResponse<{ message: string }>, AxiosError<{ message: string }>, string>({
      mutationFn: async (tokenId) => {
         const { data } = await axios.put(`${RSSB_INTEGRATION_PREFIX}/tokens/${tokenId}/activate`);
         return { data } as ApiResponse<{ message: string }>;
      },
   });
};

export const useUpdateTokenOrigin = () => {
   return useMutation<ApiResponse<{ message: string }>, AxiosError<{ message: string }>, { tokenId: string; body: ITokenUpdate }>(
      {
         mutationFn: async ({ tokenId, body }) => {
            const { data } = await axios.put(`${RSSB_INTEGRATION_PREFIX}/tokens/${tokenId}/update-origin`, body);
            return { data } as ApiResponse<{ message: string }>;
         },
      },
   );
};
